import {AppConfig} from '@ew/app-config';

export const environment: AppConfig = {
  production: false,
  baseURL: 'https://dev-api.enterwait.com/api/',
  appURL: 'https://dev-app.enterwait.com',
  webURL: 'https://dev-app.enterwait.com',
  assetsURL: 'https://dev-api.enterwait.com/assets',
};
